// A SHORT FINGERPRINT OF A STRING (FNV-1a, 32 bits, hex) — for telling two long descriptions
// apart by a word that fits in a key. Not a hash anything trusts for security: two different
// texts may share one, and the readers that use it compare like with like.
export const digest = (text: string): string => {
  let h = 0x811c9dc5;
  for (let i = 0; i < text.length; i++) h = Math.imul(h ^ text.charCodeAt(i), 0x01000193);
  return (h >>> 0).toString(16);
};
